/* Aleph Male: review carousel fed by Judge.me. Alternates photo reviews with the most recent written reviews.
   Falls back to the standard Judge.me carousel if this fails. */
(function () {
  var root = document.querySelector('[data-am-reviews]');
  if (!root || !window.fetch || !window.DOMParser) return;
  var track = root.querySelector('.am-revs__track');
  var shop = root.getAttribute('data-shop');
  var base = 'https://cdn.judge.me/reviews/all_reviews_js_based?url=' + shop + '&shop_domain=' + shop +
    '&platform=shopify&page=1&review_type=all-reviews';
  var MAX_PHOTO = 8, MAX_RECENT = 8, MIN_TEXT = 30;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }
  function txt(node, sel) {
    var f = node.querySelector(sel);
    return f ? f.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function fmtDate(raw) {
    var d = new Date((raw || '').replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return '';
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { return d.toDateString(); }
  }
  function parse(data) {
    var doc = new DOMParser().parseFromString((data && data.html) || '', 'text/html');
    return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function (rev) {
      var img = rev.querySelector('.jdgm-rev__pic-img');
      var src = img && (img.getAttribute('data-src') || img.getAttribute('src'));
      var body = txt(rev, '.jdgm-rev__body');
      if (/^\[\*+\]$/.test(body)) body = '';
      var ratingEl = rev.querySelector('.jdgm-rev__rating');
      var tsEl = rev.querySelector('.jdgm-rev__timestamp');
      return {
        id: rev.getAttribute('data-review-id'),
        src: src ? src.replace(/width=\d+/, 'width=480') : '',
        name: txt(rev, '.jdgm-rev__author'),
        title: txt(rev, '.jdgm-rev__title'),
        body: body,
        score: Math.max(0, Math.min(5, parseInt(ratingEl && ratingEl.getAttribute('data-score'), 10) || 5)),
        date: fmtDate(tsEl && tsEl.getAttribute('data-content')),
        verified: rev.getAttribute('data-verified-buyer') === 'true'
      };
    });
  }
  function card(r) {
    var c = el('article', 'am-rev' + (r.src ? '' : ' am-rev--text'));
    if (r.src) {
      var photo = el('img', 'am-rev__photo');
      photo.src = r.src;
      photo.alt = r.name ? 'Photo from ' + r.name : 'Customer photo';
      photo.loading = 'lazy';
      c.appendChild(photo);
    }
    var inner = el('div', 'am-rev__body');
    var stars = el('div', 'am-rev__stars');
    stars.setAttribute('aria-label', r.score + ' out of 5 stars');
    stars.appendChild(el('span', '', '★★★★★'.slice(0, r.score)));
    if (r.score < 5) stars.appendChild(el('span', 'am-rev__stars-off', '★★★★★'.slice(0, 5 - r.score)));
    inner.appendChild(stars);
    if (r.title) inner.appendChild(el('strong', 'am-rev__title', r.title));
    if (r.body) inner.appendChild(el('p', 'am-rev__text', r.body));
    var meta = el('div', 'am-rev__meta');
    meta.appendChild(el('span', 'am-rev__name', r.name));
    if (r.verified) meta.appendChild(el('span', 'am-rev__verified', 'Verified'));
    if (r.date) meta.appendChild(el('span', 'am-rev__date', r.date));
    inner.appendChild(meta);
    c.appendChild(inner);
    return c;
  }
  function get(url) {
    return fetch(url).then(function (r) { return r.json(); }).then(parse, function () { return []; });
  }

  Promise.all([
    get(base + '&per_page=12&sort_by=with_pictures'),
    get(base + '&per_page=20')
  ]).then(function (res) {
    var photos = res[0].filter(function (r) { return r.src; }).slice(0, MAX_PHOTO);
    var seen = {};
    photos.forEach(function (r) { seen[r.id] = 1; });
    var recent = res[1].filter(function (r) {
      return !seen[r.id] && r.score >= 4 && r.body.length >= MIN_TEXT;
    }).slice(0, MAX_RECENT);
    var list = [];
    for (var i = 0; i < Math.max(photos.length, recent.length); i++) {
      if (recent[i]) list.push(recent[i]);
      if (photos[i]) list.push(photos[i]);
    }
    if (list.length < 3) return;
    list.forEach(function (r) { track.appendChild(card(r)); });
    root.hidden = false;
    var fallback = document.querySelector('.am-revs-fallback');
    if (fallback) fallback.hidden = true;
    Array.prototype.forEach.call(root.querySelectorAll('[data-am-revs-dir]'), function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-am-revs-dir') === 'next' ? 1 : -1;
        if (getComputedStyle(track).direction === 'rtl') dir = -dir;
        track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
  }).catch(function () {});
})();
